'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA } from '../../util/constants';
import TroubleshootingToolContainer from './TroubleshootingToolContainer';

const { RECAPTCHA_KEY_V3 } = RECAPTCHA;
/**
 * @name TroubleshootingToolHomePage
 * @description Home page contains components
 * @param {object} props - Strapi and url query params data
 * @returns {JSX.Element} ReactElement
 */
const TroubleshootingToolHomePage = props => (
  <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY_V3}>
    <TroubleshootingToolContainer
      cmsData={props.cmsData}
      Utterance={props.Utterance}
      OTC={props.OTC}
      Source={props.Source}
      hasNotification={props.hasNotification}
    />
  </GoogleReCaptchaProvider>
);

export default TroubleshootingToolHomePage;
